import {brand, Branded} from 'io-ts';
import {NonEmptyString} from './NonEmptyString';

/**
 * Regex for this validator is copied from the HTML5 spec.
 *
 * > https://html.spec.whatwg.org/multipage/input.html#valid-e-mail-address
 *
 * It is compatible with Symphony's email constraint
 *
 * > https://symfony.com/doc/current/reference/constraints/Email.html
 *
 * > https://github.com/symfony/symfony/blob/a82f688a105b4f4c919b88d21c8825423c6906a9/src/Symfony/Component/Validator/Constraints/EmailValidator.php#L30C36-L30C174
 *
 * This is important to prevent false positives when validating emails
 */
export const Email = brand(
    NonEmptyString,
    (email: string): email is Email => {
        if (email.indexOf('@') === -1) {
            return false;
        }
        return RFC1123EmailRegex.test(email);
    },
    'Email'
);
export type Email = Branded<NonEmptyString, {readonly Email: unique symbol}>;

const RFC1123EmailRegex =
    // eslint-disable-next-line security/detect-unsafe-regex, no-useless-escape
    /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
